import { defineComponent as d, computed as t, openBlock as n, createBlock as u, unref as m, normalizeClass as c } from "vue";
import * as i from "../../assets/flags/index.js";
import { RevIllustration as f } from "@ds/components/Illustration";
import { tw as r } from "../../utils/tailwind.js";
const h = /* @__PURE__ */ d({
  __name: "CountryFlag",
  props: {
    countryCode: {},
    size: { default: "medium" },
    hasBorder: { type: Boolean, default: !1 }
  },
  setup(e) {
    const s = t(() => ({
      "extra-small": r`w-12`,
      small: r`w-18`,
      medium: r`w-24`,
      large: r`w-[1.875rem]`,
      "extra-large": r`w-36`
    })[e.size]), l = t(() => `border-static-default-dim border-[0.5px] ${{
      "extra-small": "rounded-[0.67px]",
      small: "rounded-[1px]",
      medium: "rounded-[1.33px]",
      large: "rounded-[1.67px]",
      "extra-large": "rounded-xs"
    }[e.size]}`), o = t(() => i[`${e.countryCode}`]);
    return (a, x) => (n(), u(m(f), {
      alt: e.countryCode,
      class: c([s.value, { [l.value]: e.hasBorder }]),
      height: 16,
      src: o.value,
      width: 24
    }, null, 8, ["alt", "class", "src"]));
  }
});
export {
  h as default
};
